import { Link } from "@tanstack/react-router";
import { ChevronRightIcon, SparklesIcon, ZapIcon } from "lucide-react";

import { DropdownMenuGroup, DropdownMenuSeparator } from "@/components/ui/dropdown-menu";
import { Skeleton } from "@/components/ui/skeleton";
import { useBalance, useSubscriptions } from "@/hooks/query/billing";
import { getPlanByName } from "@/lib/subscriptions/subscriptions";
import * as m from "@/paraglide/messages";

export function PlanCreditsCard() {
	const { data: subscriptions, isPending: subPending } = useSubscriptions();

	const { data: balance, isPending: balPending } = useBalance();

	const activeSub = subscriptions?.find((s) => s.status === "active" || s.status === "trialing");
	const currentPlan = getPlanByName(activeSub?.plan ?? "free")!;
	const isFree = !activeSub;

	if (subPending && balPending) {
		return (
			<>
				<DropdownMenuSeparator />
				<DropdownMenuGroup>
					<div className="px-2 py-1.5">
						<Skeleton className="h-4 w-24" />
					</div>
					<div className="px-2 py-1.5">
						<Skeleton className="h-4 w-32" />
					</div>
				</DropdownMenuGroup>
			</>
		);
	}

	return (
		<>
			<DropdownMenuSeparator />
			<DropdownMenuGroup>
				<div className="flex items-center justify-between rounded-sm px-2 py-1.5">
					<div className="flex items-center gap-1.5 text-xs">
						<ZapIcon className="size-4 text-amber-500" />
						<span className="font-medium">{currentPlan?.label ?? "Free"}</span>
					</div>
					{isFree && (
						<Link
							to="/settings/subscription"
							className="inline-flex items-center rounded-full bg-primary px-2 py-0.5 text-[10px] font-medium text-primary-foreground hover:bg-primary/90 transition-colors"
						>
							{m.userDropdown_upgrade()}
						</Link>
					)}
				</div>
				<Link
					to="/settings/usage"
					className="flex items-center justify-between rounded-sm px-2 py-1.5 text-xs hover:bg-accent transition-colors cursor-default"
				>
					<div className="flex items-center gap-1.5 text-muted-foreground">
						<SparklesIcon className="size-4" />
						<span>{m.userDropdown_credits()}</span>
					</div>
					<div className="flex items-center gap-1">
						{balPending ? (
							<Skeleton className="h-3.5 w-8" />
						) : (
							<span className="tabular-nums font-medium text-foreground">
								{(balance ?? 0).toLocaleString()}
							</span>
						)}
						<ChevronRightIcon className="size-3.5 text-muted-foreground" />
					</div>
				</Link>
			</DropdownMenuGroup>
		</>
	);
}
